var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('a',{class:_vm.classes,attrs:{"href":_vm.href,"target":_vm.target},domProps:{"innerHTML":_vm._s(_vm.settings.label)},on:{"click":function($event){return _vm.clicked($event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }